// // import { motion } from 'framer-motion';
// // import { Link } from 'react-router-dom';
// // import { FiArrowLeft, FiTrendingUp } from "react-icons/fi";
// // import { FaBalanceScale, FaLightbulb, FaBullhorn, FaPhoneAlt, FaEnvelope, FaCity, FaCheckCircle } from "react-icons/fa";

// // export default function MemberShipOverview() {
// //   const valuePropositions = [
// //     {
// //       title: "Business Growth Opportunities",
// //       icon: <FiTrendingUp className="w-8 h-8 text-brand-btn-orange" />,
// //       emoji: "📈",
// //       points: [
// //         "Access to curated B2B matchmaking platforms connecting industry leaders, investors, and global partners.",
// //         "Opportunity to secure a Managing Committee seat, enabling you to contribute to strategic direction while strengthening your industry presence.",
// //         "Participation in domestic & international trade delegations to explore new markets and opportunities.",
// //         "Work closely with industry leaders in councils and committees to unlock collaboration opportunities."
// //       ]
// //     },
// //     {
// //       title: "Policy Advocacy & Ease of Doing Business",
// //       icon: <FaBalanceScale className="w-8 h-8 text-brand-red" />,
// //       emoji: "⚖️",
// //       points: [
// //         "Representation before key Ministries, Regulators, and Government bodies on critical industry issues.",
// //         "Contribute to key policy discussions through consultations, working groups, and National & State Councils.",
// //         "Share practical industry feedback through structured representations and position papers.",
// //         "Timely escalation and resolution support on policy, compliance, and regulatory challenges."
// //       ]
// //     },
// //     {
// //       title: "Knowledge Hub",
// //       icon: <FaLightbulb className="w-8 h-8 text-brand-btn-orange" />,
// //       emoji: "💡",
// //       points: [
// //         "Access to policy & regulatory updates, exclusive research reports and industry insights.",
// //         "Access to industry Best Practices.",
// //         "Access to ASSOCHAM flagship events.",
// //         "Access to ASSOCHAM exclusive Member-only engagements."
// //       ]
// //     },
// //     {
// //       title: "Visibility & Outreach",
// //       icon: <FaBullhorn className="w-8 h-8 text-brand-red" />,
// //       emoji: "📣",
// //       points: [
// //         "Speaking opportunities at national and international forums.",
// //         "Opportunities for leadership positions in ASSOCHAM Councils & government committees enhancing credibility and market presence.",
// //         "Increased engagement and visibility across government networks/initiatives towards Viksit Bharat.",
// //         "Brand showcasing through ASSOCHAM website, sponsorships, exhibitions, and flagship ASSOCHAM events."
// //       ]
// //     }
// //   ];

// //   const helpDesk = [
// //     { name: "Sunita Dobhal", phone: "+91 9818325433", email: "sunita.dobhal@assocham.com" },
// //     { name: "Gautam Sengupta", phone: "+91 9999311483", email: "gautam.sengupta@assocham.com" },
// //     { name: "Nusrat Wajahat", phone: "+91 9868906133", email: "nusrat.wajahat@assocham.com" },
// //     { name: "Hrithik Verma", phone: "+91 7838981998", email: "hrithik.verma@assocham.com" }
// //   ];

// //   const fadeUpVariant = {
// //     hidden: { opacity: 0, y: 30 },
// //     visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
// //   };

// //   return (
// //     <div className="min-h-screen bg-brand-light font-sans text-gray-800 selection:bg-brand-orange selection:text-white">
// //       {/* Navigation Bar */}
// //       <nav className="bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-brand-peach px-6 lg:px-20 py-4">
// //         <div className="max-w-7xl mx-auto flex items-center">
// //           <Link to="/" className="flex items-center gap-2 text-brand-orange hover:text-brand-red font-semibold transition-colors">
// //             <FiArrowLeft className="w-5 h-5" /> Back to Membership
// //           </Link>
// //         </div>
// //       </nav>

// //       {/* Hero Section */}
// //       <header className="bg-brand-cream py-20 px-6 lg:px-20 relative overflow-hidden">
// //         <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-bl from-brand-peach to-transparent opacity-50 pointer-events-none"></div>
// //         <motion.div 
// //           initial="hidden"
// //           animate="visible"
// //           variants={fadeUpVariant}
// //           className="max-w-4xl mx-auto text-center relative z-10"
// //         >
// //           <div className="inline-block px-4 py-1.5 rounded-full bg-brand-orange/10 text-brand-red text-sm font-bold tracking-widest uppercase mb-6 border border-brand-orange/20">
// //             Membership
// //           </div>
// //           <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-6">
// //             ASSOCHAM: The Knowledge Architect Of India
// //           </h1>
// //           <div className="w-24 h-1 bg-gradient-to-r from-brand-orange to-brand-red mx-auto rounded-full"></div>
// //         </motion.div>
// //       </header>

// //       {/* Full Overview Section */}
// //       <section className="py-20 px-6 lg:px-20 bg-brand-light">
// //         <div className="max-w-4xl mx-auto">
// //           <motion.div 
// //             initial={{ opacity: 0, scale: 0.95 }}
// //             whileInView={{ opacity: 1, scale: 1 }}
// //             viewport={{ once: true }}
// //             className="flex items-center gap-4 mb-10 border-b pb-6 border-gray-100"
// //           >
// //             <div className="w-16 h-16 rounded-2xl bg-brand-peach flex items-center justify-center shadow-sm">
// //               <FaCity className="w-8 h-8 text-brand-red" />
// //             </div>
// //             <h2 className="text-4xl font-bold text-gray-900">Overview</h2>
// //           </motion.div>

// //           <motion.div 
// //             initial="hidden"
// //             whileInView="visible"
// //             viewport={{ once: true, margin: "-100px" }}
// //             variants={{
// //               visible: { transition: { staggerChildren: 0.1 } }
// //             }}
// //             className="bg-white p-8 md:p-12 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 space-y-6 text-gray-600 leading-relaxed text-justify"
// //           >
// //             {[
// //               "Aligned with the vision of creating a New India, ASSOCHAM works closely with the Government, industry, and civil society. The Chamber is an agile and forward-looking institution, leading various initiatives to enhance the global competitiveness of the Indian industry.",
// //               "With more than 100 National and regional councils, ASSOCHAM is an impactful representative of the Indian industry. ASSOCHAM Councils and taskforce focus on different sectors and growth segments, working with the Central and State Government stakeholders. The Chamber focuses on aligning critical needs and interests of the industry with the growth aspirations of the nation through policy advocacy and advisory practices.",
// //               "Members are offered various networking opportunities to discuss innovative solutions to trends and challenges, help unlocking the full potential of the Indian ecosystem. The Chamber organizes multiple conferences/ seminars/ workshops and interactive sessions with the policymakers. ASSOCHAM has the honour of hosting Policymakers, Foreign Business Delegations, World Leaders, Renowned Industrialists, Economists, Investors, Scientists, Bankers, and social activists. It also frequently organizes delegations to countries of key trade and business importance, coordinating trade and investment promotion and providing the Indian industry with strategic global linkages with the international business community.",
// //               "Our eminent members are from the leading companies in India, major business houses including MSMEs, Public Sector Undertakings, Women Entrepreneurs, Multinational Companies, Banks, Financial Institutions, Start-ups and Professionals Firms to mention a few. These thought leaders are engaged to bring in best practices and insights that can help the industry address challenges and chart a robust growth path for the country. ASSOCHAM continuously strives to provide the highest value addition to its entire cross-section of members, even offering them a range of specialized services.",
// //               "Aligned with its focus on inclusive development, the Chamber also supports civil society through citizenship programmes. ASSOCHAM’s member network leads initiatives in various segments such as empowerment, healthcare, education and skilling, hygiene, affirmative action, road safety, livelihood, life skills, sustainability, to name a few.",
// //               "ASSOCHAM’s mission is to impact the policy and legislative environment to foster balanced economic, industrial, and social development."
// //             ].map((text, i) => (
// //               <motion.p key={i} variants={fadeUpVariant} className="text-base md:text-lg">
// //                 {text}
// //               </motion.p>
// //             ))}
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* Value Proposition */}
// //       <section className="py-24 px-6 lg:px-20 bg-brand-cream relative">
// //         <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-peach via-brand-cream to-brand-cream"></div>
// //         <div className="max-w-7xl mx-auto relative z-10">
// //           <div className="text-center mb-16">
// //             <h2 className="text-4xl font-bold text-gray-900 mb-4">Membership Value Proposition</h2>
// //             <p className="text-gray-600 max-w-2xl mx-auto text-lg">
// //               Unlock a world of opportunities, strategic insights, and impactful networking.
// //             </p>
// //           </div>

// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
// //             {valuePropositions.map((vp, index) => (
// //               <motion.div
// //                 key={index}
// //                 initial={{ opacity: 0, y: 40 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 viewport={{ once: true }}
// //                 transition={{ duration: 0.5, delay: index * 0.1 }}
// //                 className="bg-white rounded-3xl p-8 lg:p-10 shadow-xl shadow-gray-200/40 border border-brand-peach hover:-translate-y-2 transition-transform duration-300"
// //               >
// //                 <div className="flex items-center gap-4 mb-8">
// //                   <div className="w-16 h-16 rounded-2xl bg-brand-beige flex items-center justify-center text-3xl shadow-inner border border-brand-peach/50">
// //                     {vp.emoji}
// //                   </div>
// //                   <h3 className="text-2xl font-bold text-gray-900 leading-tight flex-1">
// //                     {vp.title}
// //                   </h3>
// //                 </div>
                
// //                 <ul className="space-y-5">
// //                   {vp.points.map((point, i) => (
// //                     <li key={i} className="flex items-start gap-4 group">
// //                       <FaCheckCircle className="w-5 h-5 text-brand-orange flex-shrink-0 mt-1 group-hover:text-brand-red transition-colors" />
// //                       <span className="text-gray-700 leading-relaxed group-hover:text-gray-900 transition-colors">
// //                         {point}
// //                       </span>
// //                     </li>
// //                   ))}
// //                 </ul>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Help Desk */}
// //       <section className="py-20 px-6 lg:px-20 bg-brand-light">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-10 lg:p-16 border border-gray-700 shadow-2xl relative overflow-hidden text-white">
// //             <div className="absolute top-0 right-0 w-64 h-64 bg-brand-red rounded-full -mr-32 -mt-32 opacity-20 blur-3xl"></div>
// //             <div className="absolute bottom-0 left-0 w-48 h-48 bg-brand-btn-orange rounded-full -ml-24 -mb-24 opacity-20 blur-3xl"></div>
            
// //             <h3 className="text-3xl font-bold mb-10 relative z-10 text-center lg:text-left text-white">Membership Help Desk</h3>
            
// //             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
// //               {helpDesk.map((person, index) => (
// //                 <div key={index} className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-sm border border-white/10 hover:bg-white/20 transition-colors">
// //                   <h5 className="font-bold text-lg text-brand-peach mb-4">{person.name}</h5>
// //                   <div className="space-y-4">
// //                     <a href={`tel:${person.phone}`} className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors">
// //                       <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
// //                         <FaPhoneAlt className="w-4 h-4 text-brand-btn-orange" />
// //                       </div>
// //                       <span className="text-sm font-medium tracking-wide">{person.phone}</span>
// //                     </a>
// //                     <a href={`mailto:${person.email}`} className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors">
// //                       <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
// //                         <FaEnvelope className="w-4 h-4 text-brand-btn-orange" />
// //                       </div>
// //                       <span className="text-sm font-medium break-all">{person.email}</span>
// //                     </a>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // }





// // new new code 






// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import { FiArrowLeft, FiTrendingUp } from "react-icons/fi";
// import { FaBalanceScale, FaLightbulb, FaBullhorn, FaPhoneAlt, FaEnvelope, FaCity, FaCheckCircle } from "react-icons/fa";

// export default function MemberShipOverview() {
//   const valuePropositions = [
//     {
//       title: "Business Growth Opportunities",
//       icon: <FiTrendingUp className="w-8 h-8 text-white" />,
//       emoji: "📈",
//       points: [
//         "Access to curated B2B matchmaking platforms connecting industry leaders, investors, and global partners.",
//         "Opportunity to secure a Managing Committee seat, enabling you to contribute to strategic direction while strengthening your industry presence.",
//         "Participation in domestic & international trade delegations to explore new markets and opportunities.",
//         "Work closely with industry leaders in councils and committees to unlock collaboration opportunities."
//       ]
//     },
//     {
//       title: "Policy Advocacy & Ease of Doing Business",
//       icon: <FaBalanceScale className="w-8 h-8 text-white" />,
//       emoji: "⚖️",
//       points: [
//         "Representation before key Ministries, Regulators, and Government bodies on critical industry issues.",
//         "Contribute to key policy discussions through consultations, working groups, and National & State Councils.",
//         "Share practical industry feedback through structured representations and position papers.",
//         "Timely escalation and resolution support on policy, compliance, and regulatory challenges."
//       ]
//     },
//     {
//       title: "Knowledge Hub",
//       icon: <FaLightbulb className="w-8 h-8 text-white" />,
//       emoji: "💡",
//       points: [
//         "Access to policy & regulatory updates, exclusive research reports and industry insights.",
//         "Access to industry Best Practices.",
//         "Access to ASSOCHAM flagship events.",
//         "Access to ASSOCHAM exclusive Member-only engagements."
//       ]
//     },
//     {
//       title: "Visibility & Outreach",
//       icon: <FaBullhorn className="w-8 h-8 text-white" />,
//       emoji: "📣",
//       points: [
//         "Speaking opportunities at national and international forums.",
//         "Opportunities for leadership positions in ASSOCHAM Councils & government committees enhancing credibility and market presence.",
//         "Increased engagement and visibility across government networks/initiatives towards Viksit Bharat.",
//         "Brand showcasing through ASSOCHAM website, sponsorships, exhibitions, and flagship ASSOCHAM events."
//       ]
//     }
//   ];

//   const helpDesk = [
//     { name: "Sunita Dobhal", phone: "+91 9818325433", email: "sunita.dobhal@assocham.com" },
//     { name: "Gautam Sengupta", phone: "+91 9999311483", email: "gautam.sengupta@assocham.com" },
//     { name: "Nusrat Wajahat", phone: "+91 9868906133", email: "nusrat.wajahat@assocham.com" },
//     { name: "Hrithik Verma", phone: "+91 7838981998", email: "hrithik.verma@assocham.com" }
//   ];

//   const fadeUpVariant = {
//     hidden: { opacity: 0, y: 30 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
//   };

//   return (
//     <div className="min-h-screen bg-brand-light font-sans text-gray-800 selection:bg-[#DA2128] selection:text-white">
//       {/* Navigation Bar */}
//       <nav className="bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-brand-peach px-6 lg:px-20 py-4">
//         <div className="max-w-7xl mx-auto flex items-center">
//           <Link to="/membership" className="flex items-center gap-2 text-[#DA2128] hover:text-[#A5161C] font-semibold transition-colors">
//             <FiArrowLeft className="w-5 h-5" /> Back to Membership
//           </Link>
//         </div>
//       </nav>

//       {/* Hero Section */}
//       <header className="relative bg-gradient-to-br from-white via-[#FFF5F3] to-[#FFE8E4] py-12 px-6 lg:px-20 overflow-hidden">
//         {/* Subtle Animated Background Elements */}
//         <div className="absolute inset-0">
//           <div className="absolute top-[-30%] right-[-20%] w-[50%] h-[70%] bg-[radial-gradient(ellipse_at_center,_rgba(218,33,40,0.06)_0%,_transparent_70%)]"></div>
//           <div className="absolute bottom-[-30%] left-[-20%] w-[50%] h-[70%] bg-[radial-gradient(ellipse_at_center,_rgba(232,93,40,0.05)_0%,_transparent_70%)]"></div>
//         </div>

//         {/* Abstract Decorative Shapes */}
//         <motion.div
//           className="absolute top-10 right-16 w-32 h-32 rounded-full border border-[#DA2128]/10"
//           animate={{
//             scale: [1, 1.1, 1],
//             rotate: [0, 180, 360],
//           }}
//           transition={{
//             duration: 20,
//             repeat: Infinity,
//             ease: "linear"
//           }}
//         />
//         <motion.div
//           className="absolute bottom-10 left-16 w-24 h-24 rounded-full border border-[#E85D28]/10"
//           animate={{
//             scale: [1, 1.2, 1],
//             rotate: [360, 180, 0],
//           }}
//           transition={{
//             duration: 15,
//             repeat: Infinity,
//             ease: "linear"
//           }}
//         />
        
//         {/* Small geometric accents */}
//         <div className="absolute top-1/3 right-8 w-12 h-12 bg-[#DA2128]/5 rounded-lg transform rotate-45"></div>
//         <div className="absolute bottom-1/4 left-8 w-10 h-10 bg-[#E85D28]/5 rounded-lg transform rotate-12"></div>
//         <div className="absolute top-1/4 left-1/3 w-6 h-6 bg-[#DA2128]/5 rounded-full"></div>

//         {/* Dots Pattern */}
//         <div className="absolute inset-0 opacity-20">
//           <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
//             <defs>
//               <pattern id="dots" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
//                 <circle cx="2" cy="2" r="1" fill="#DA2128" opacity="0.3"/>
//               </pattern>
//             </defs>
//             <rect width="100%" height="100%" fill="url(#dots)" />
//           </svg>
//         </div>

//         {/* Content */}
//         <motion.div 
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, ease: "easeOut" }}
//           className="relative z-10 max-w-7xl mx-auto text-center"
//         >
//           {/* MEMBERSHIP Badge */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.4, delay: 0.1 }}
//             className="inline-block mb-4"
//           >
//             <div className="relative">
//               <div className="relative bg-white/90 backdrop-blur-sm px-6 py-2 rounded-full shadow-md border border-[#DA2128]/10">
//                 <span className="text-xs font-bold tracking-[0.15em] text-[#DA2128] uppercase">
//                   <span className="inline-block mr-2 text-[#DA2128]">●</span>
//                   Membership
//                 </span>
//               </div>
//             </div>
//           </motion.div>

//           {/* Main Heading - Compact */}
//           <motion.h1
//             initial={{ opacity: 0, y: 10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.2 }}
//             className="text-4xl md:text-6xl font-extrabold leading-[1.1]"
//           >
//             <motion.span
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 0.6, delay: 0.3 }}
//               className="bg-gradient-to-r from-[#DA2128] via-[#E85D28] to-[#DA2128] bg-clip-text text-transparent bg-300% animate-gradient"
//             >
//               ASSOCHAM
//             </motion.span>
//             <br />
//             <span className="text-gray-800 text-2xl md:text-3xl block mt-1">
//               The Knowledge Architect
//             </span>
//             <span className="text-gray-600 text-xl md:text-2xl block font-medium">
//               Of India
//             </span>
//           </motion.h1>

//           {/* Tagline */}
//           <motion.p
//             initial={{ opacity: 0, y: 10 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.4 }}
//             className="text-gray-500 max-w-2xl mx-auto text-sm md:text-base font-light tracking-wide mt-3"
//           >
//             Empowering India's Growth Through Strategic Industry Leadership
//           </motion.p>

//           {/* Decorative Dots */}
//           <motion.div
//             initial={{ opacity: 0, scaleX: 0 }}
//             animate={{ opacity: 1, scaleX: 1 }}
//             transition={{ duration: 0.6, delay: 0.5 }}
//             className="mt-4 flex justify-center gap-1.5"
//           >
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/30"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/50"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/70"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/70"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/50"></div>
//             <div className="w-1.5 h-1.5 rounded-full bg-[#DA2128]/30"></div>
//           </motion.div>
//         </motion.div>

//         {/* Corner Accents */}
//         <div className="absolute bottom-0 left-0 w-24 h-24 border-l border-b border-[#DA2128]/5 rounded-bl-2xl"></div>
//         <div className="absolute top-0 right-0 w-24 h-24 border-r border-t border-[#DA2128]/5 rounded-tr-2xl"></div>
        
//         {/* Bottom Accent Line */}
//         <div className="absolute bottom-0 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-transparent via-[#DA2128]/30 to-transparent"></div>
//       </header>

//       {/* Full Overview Section */}
//       <section className="py-20 px-6 lg:px-20 bg-brand-light">
//         <div className="max-w-4xl mx-auto">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.95 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true }}
//             className="flex items-center gap-4 mb-10 border-b pb-6 border-gray-100"
//           >
//             <div className="w-16 h-16 rounded-2xl bg-[#DA2128]/10 flex items-center justify-center shadow-sm">
//               <FaCity className="w-8 h-8 text-[#DA2128]" />
//             </div>
//             <h2 className="text-4xl font-bold text-gray-900">Overview</h2>
//           </motion.div>

//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true, margin: "-100px" }}
//             variants={{
//               visible: { transition: { staggerChildren: 0.1 } }
//             }}
//             className="bg-white p-8 md:p-12 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 space-y-6 text-gray-600 leading-relaxed text-justify"
//           >
//             {[
//               "Aligned with the vision of creating a New India, ASSOCHAM works closely with the Government, industry, and civil society. The Chamber is an agile and forward-looking institution, leading various initiatives to enhance the global competitiveness of the Indian industry.",
//               "With more than 100 National and regional councils, ASSOCHAM is an impactful representative of the Indian industry. ASSOCHAM Councils and taskforce focus on different sectors and growth segments, working with the Central and State Government stakeholders. The Chamber focuses on aligning critical needs and interests of the industry with the growth aspirations of the nation through policy advocacy and advisory practices.",
//               "Members are offered various networking opportunities to discuss innovative solutions to trends and challenges, help unlocking the full potential of the Indian ecosystem. The Chamber organizes multiple conferences/ seminars/ workshops and interactive sessions with the policymakers. ASSOCHAM has the honour of hosting Policymakers, Foreign Business Delegations, World Leaders, Renowned Industrialists, Economists, Investors, Scientists, Bankers, and social activists. It also frequently organizes delegations to countries of key trade and business importance, coordinating trade and investment promotion and providing the Indian industry with strategic global linkages with the international business community.",
//               "Our eminent members are from the leading companies in India, major business houses including MSMEs, Public Sector Undertakings, Women Entrepreneurs, Multinational Companies, Banks, Financial Institutions, Start-ups and Professionals Firms to mention a few. These thought leaders are engaged to bring in best practices and insights that can help the industry address challenges and chart a robust growth path for the country. ASSOCHAM continuously strives to provide the highest value addition to its entire cross-section of members, even offering them a range of specialized services.",
//               "Aligned with its focus on inclusive development, the Chamber also supports civil society through citizenship programmes. ASSOCHAM's member network leads initiatives in various segments such as empowerment, healthcare, education and skilling, hygiene, affirmative action, road safety, livelihood, life skills, sustainability, to name a few.",
//               "ASSOCHAM's mission is to impact the policy and legislative environment to foster balanced economic, industrial, and social development."
//             ].map((text, i) => (
//               <motion.p key={i} variants={fadeUpVariant} className="text-base md:text-lg">
//                 {text}
//               </motion.p>
//             ))}
//           </motion.div>
//         </div>
//       </section>

//       {/* Value Proposition */}
//       <section className="py-24 px-6 lg:px-20 bg-brand-cream relative">
//         <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#DA2128]/10 via-brand-cream to-brand-cream"></div>
//         <div className="max-w-7xl mx-auto relative z-10">
//           <div className="text-center mb-16">
//             <div className="inline-block px-6 py-2.5 rounded-full border border-[#DA2128]/30 mb-6">
//               <h2 className="text-lg md:text-xl font-serif font-bold text-gray-900">Membership Value Proposition</h2>
//             </div>
//             <p className="text-gray-600 max-w-2xl mx-auto text-lg">
//               Unlock a world of opportunities, strategic insights, and impactful networking.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
//             {valuePropositions.map((vp, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 40 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 className="rounded-3xl overflow-hidden shadow-xl shadow-gray-200/40 border border-[#DA2128]/10 bg-white hover:-translate-y-2 transition-transform duration-300"
//               >
//                 {/* Colored header bar */}
//                 <div className="flex items-center gap-4 bg-[#DA2128] px-6 py-6 sm:px-8">
//                   <div className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center text-2xl shrink-0">
//                     {vp.emoji}
//                   </div>
//                   <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white leading-tight">
//                     {vp.title}
//                   </h3>
//                 </div>

//                 {/* Body */}
//                 <ul className="space-y-4 px-6 py-8 sm:px-8 bg-[#FDF2F1]">
//                   {vp.points.map((point, i) => (
//                     <li key={i} className="flex items-start gap-3 group">
//                       <span className="mt-2 w-2 h-2 rounded-full bg-[#DA2128] shrink-0 group-hover:scale-125 transition-transform" />
//                       <span className="text-gray-700 leading-relaxed text-sm md:text-base group-hover:text-gray-900 transition-colors">
//                         {point}
//                       </span>
//                     </li>
//                   ))}
//                 </ul>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Help Desk */}
//             <section className="py-20 px-6 lg:px-20 bg-brand-light">
//         <div className="max-w-7xl mx-auto">
//           <div className="bg-brand-beige rounded-3xl p-10 lg:p-16 border border-brand-peach shadow-lg relative overflow-hidden">
//             <div className="absolute top-0 right-0 w-64 h-64 bg-brand-peach rounded-full -mr-32 -mt-32 opacity-50"></div>
//             <div className="absolute bottom-0 left-0 w-48 h-48 bg-brand-cream rounded-full -ml-24 -mb-24 opacity-80"></div>

//             <h3 className="text-3xl font-bold mb-10 text-gray-900 relative z-10 text-center lg:text-left">Membership Help Desk</h3>

//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
//               {helpDesk.map((person, index) => (
//                 <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
//                   <h5 className="font-bold text-lg text-[#DA2128] mb-4">{person.name}</h5>
//                   <div className="space-y-3">
//                     <a href={`tel:${person.phone}`} className="flex items-center gap-3 text-gray-600 hover:text-[#DA2128] transition-colors">
//                       <div className="w-8 h-8 rounded-full bg-[#DA2128]/10 flex items-center justify-center flex-shrink-0">
//                         <FaPhoneAlt className="w-4 h-4 text-[#DA2128]" />
//                       </div>
//                       <span className="text-sm font-medium">{person.phone}</span>
//                     </a>
//                     <a href={`mailto:${person.email}`} className="flex items-center gap-3 text-gray-600 hover:text-[#DA2128] transition-colors">
//                       <div className="w-8 h-8 rounded-full bg-[#DA2128]/10 flex items-center justify-center flex-shrink-0">
//                         <FaEnvelope className="w-4 h-4 text-[#DA2128]" />
//                       </div>
//                       <span className="text-sm font-medium break-all">{person.email}</span>
//                     </a>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <p className="max-w-3xl mx-auto text-center mt-6">
//               Any dispute/legal case is to be initiated against ASSOCHAM within the jurisdiction of its Registered Office at New Delhi only.
//             </p>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }






// new new code 




import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiArrowUpRight, FiMail, FiMapPin, FiPhone, FiTrendingUp } from "react-icons/fi";
import {
  FaBalanceScale,
  FaLightbulb,
  FaBullhorn,
  FaPhoneAlt,
  FaEnvelope,
  FaCity,
  FaMapMarkerAlt,
  FaUserFriends,
  FaBriefcase,
  FaGlobe,
} from "react-icons/fa";
import HelpDeskSection from "./HelpDeskSection";

/* Reversed "file-folder" silhouette — tab on the top-left instead of top-right */
const FOLDER_CLIP_REVERSED =
  "polygon(16px 0, 0 16px, 0 calc(100% - 16px), 16px 100%, calc(100% - 16px) 100%, 100% calc(100% - 16px), 100% 30px, calc(100% - 40%) 30px, calc(100% - 52%) 0)";

export default function MemberShipOverview() {
  const valuePropositions = [
    {
      title: "Business Growth Opportunities",
      icon: <FiTrendingUp className="w-6 h-6" />,
      gradient: "from-amber-500 to-orange-400",
      hex: "#f59e0b",
      points: [
        "Access to curated B2B matchmaking platforms connecting industry leaders, investors, and global partners.",
        "Opportunity to secure a Managing Committee seat, enabling you to contribute to strategic direction while strengthening your industry presence.",
        "Participation in domestic & international trade delegations to explore new markets and opportunities.",
        "Work closely with industry leaders in councils and committees to unlock collaboration opportunities.",
      ],
    },
    {
      title: "Policy Advocacy & Ease of Doing Business",
      icon: <FaBalanceScale className="w-6 h-6" />,
      gradient: "from-amber-500 to-orange-400",
      hex: "#f59e0b",
      points: [
        "Representation before key Ministries, Regulators, and Government bodies on critical industry issues.",
        "Contribute to key policy discussions through consultations, working groups, and National & State Councils.",
        "Share practical industry feedback through structured representations and position papers.",
        "Timely escalation and resolution support on policy, compliance, and regulatory challenges.",
      ],
    },
    {
      title: "Knowledge Hub",
      icon: <FaLightbulb className="w-6 h-6" />,
      gradient: "from-amber-500 to-orange-400",
      hex: "#f59e0b",
      points: [
        "Access to policy & regulatory updates, exclusive research reports and industry insights.",
        "Access to industry Best Practices.",
        "Access to ASSOCHAM flagship events.",
        "Access to ASSOCHAM exclusive Member-only engagements.",
      ],
    },
    {
      title: "Visibility & Outreach",
      icon: <FaBullhorn className="w-6 h-6" />,
      gradient: "from-amber-500 to-orange-400",
      hex: "#f59e0b",
      points: [
        "Speaking opportunities at national and international forums.",
        "Opportunities for leadership positions in ASSOCHAM Councils & government committees enhancing credibility and market presence.",
        "Increased engagement and visibility across government networks/initiatives towards Viksit Bharat.",
        "Brand showcasing through ASSOCHAM website, sponsorships, exhibitions, and flagship ASSOCHAM events.",
      ],
    },
  ];

  const stats = [
    { number: "14", label: "State offices in India", icon: <FaMapMarkerAlt className="w-5 h-5" /> },
    { number: "250+", label: "Associations in India and Overseas", icon: <FaGlobe className="w-5 h-5" /> },
    { number: "450,000+", label: "Direct & Indirect Memberships", icon: <FaUserFriends className="w-5 h-5" /> },
    { number: "150+", label: "Strong ASSOCHAM Team", icon: <FaBriefcase className="w-5 h-5" /> },
  ];

const helpDesk = [
  {
    name: "Sunita Dobhal",
    phone: "+91 9818325433",
    email: "sunita.dobhal@assocham.com",
    role: "Executive Director",
  },
  {
    name: "Gautam Sengupta",
    phone: "+91 9999311483",
    email: "gautam.sengupta@assocham.com",
    role: "Assistant Manager",
  },
  {
    name: "Nusrat Wajahat",
    phone: "+91 9868906133",
    email: "nusrat.wajahat@assocham.com",
    role: "Senior Executive",
  },
  {
    name: "Hrithik Verma",
    phone: "+91 7838981998",
    email: "hrithik.verma@assocham.com",
    role: "Senior Executive",
  },
];

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <div className="min-h-screen bg-[#FDFBF9] font-sans text-gray-800 selection:bg-[#DA2128] selection:text-white">
      {/* Navigation Bar */}
      <nav className="bg-white/90 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100 px-6 lg:px-20 py-4 shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link
            to="/membership"
            className="flex items-center gap-2 text-[#DA2128] hover:text-[#A5161C] font-semibold transition-all group"
          >
            <FiArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            <span>Back to Membership</span>
          </Link>
          <div className="hidden md:flex items-center gap-2 text-sm text-gray-500">
            <span className="w-2 h-2 rounded-full bg-[#DA2128] animate-pulse" />
            <span>ASSOCHAM Overview</span>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="relative bg-gradient-to-br from-white via-[#FFF5F3] to-[#FFE8E4] py-20 px-6 lg:px-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-[-30%] right-[-20%] w-[50%] h-[70%] bg-[radial-gradient(ellipse_at_center,_rgba(218,33,40,0.08)_0%,_transparent_70%)]" />
          <div className="absolute bottom-[-30%] left-[-20%] w-[50%] h-[70%] bg-[radial-gradient(ellipse_at_center,_rgba(232,93,40,0.06)_0%,_transparent_70%)]" />
        </div>

        <motion.div
          className="absolute top-10 right-20 w-40 h-40 rounded-full border-2 border-[#DA2128]/10"
          animate={{ scale: [1, 1.1, 1], rotate: [0, 180, 360] }}
          transition={{ duration: 25, repeat: Infinity, ease: "linear" }}
        />
        <motion.div
          className="absolute bottom-10 left-20 w-28 h-28 rounded-full border-2 border-[#E85D28]/10"
          animate={{ scale: [1, 1.2, 1], rotate: [360, 180, 0] }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="relative z-10 max-w-4xl mx-auto text-center"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            className="inline-block mb-6"
          >
            <div className="relative bg-white/90 backdrop-blur-sm px-8 py-2.5 rounded-full shadow-lg border border-[#DA2128]/10">
              <span className="text-sm font-bold tracking-[0.2em] text-[#DA2128] uppercase">
                <span className="inline-block mr-2 text-[#DA2128]">◆</span>
                Membership Overview
              </span>
            </div>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-[1.1]"
          >
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6 }}
              className="bg-gradient-to-r from-[#DA2128] via-[#E85D28] to-[#DA2128] bg-clip-text text-transparent"
              style={{
                backgroundSize: "300% 300%",
                animation: "gradientPan 7s ease infinite",
              }}
            >
              ASSOCHAM
            </motion.span>
            <br />
            <span className="text-gray-800 text-2xl md:text-4xl block mt-2">
              The Knowledge Architect
            </span>
            <span className="text-gray-600 text-xl md:text-3xl block font-medium">Of India</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-gray-500 max-w-2xl mx-auto text-base md:text-lg font-light tracking-wide mt-4"
          >
            Empowering India's Growth Through Strategic Industry Leadership
          </motion.p>

          <motion.div
            initial={{ opacity: 0, scaleX: 0 }}
            animate={{ opacity: 1, scaleX: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mt-6 flex justify-center gap-2"
          >
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className={`w-2 h-2 rounded-full ${i === 2 ? "bg-[#DA2128]" : "bg-[#DA2128]/30"}`}
              />
            ))}
          </motion.div>
        </motion.div>

        {/* Inline keyframes so this file is fully self-contained (no tailwind.config needed) */}
        <style>{`
          @keyframes gradientPan {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}</style>
      </header>


      {/* Overview Section */}
      <section className="py-20 px-6 lg:px-20 bg-[#FDFBF9]">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex items-center gap-4 mb-12"
          >
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#DA2128] to-[#E85D28] flex items-center justify-center shadow-lg shadow-[#DA2128]/20">
              <FaCity className="w-7 h-7 text-white" />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Overview</h2>
              <p className="text-gray-500 text-sm">Understanding ASSOCHAM's vision and impact</p>
            </div>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
            className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-gray-200/50 border border-gray-100 space-y-6 text-gray-600 leading-relaxed"
          >
            {[
              "Aligned with the vision of creating a New India, ASSOCHAM works closely with the Government, industry, and civil society. The Chamber is an agile and forward-looking institution, leading various initiatives to enhance the global competitiveness of the Indian industry.",
              "With more than 100 National and regional councils, ASSOCHAM is an impactful representative of the Indian industry. ASSOCHAM Councils and taskforce focus on different sectors and growth segments, working with the Central and State Government stakeholders. The Chamber focuses on aligning critical needs and interests of the industry with the growth aspirations of the nation through policy advocacy and advisory practices.",
              "Members are offered various networking opportunities to discuss innovative solutions to trends and challenges, help unlocking the full potential of the Indian ecosystem. The Chamber organizes multiple conferences, seminars, workshops and interactive sessions with the policymakers.",
              "Our eminent members are from the leading companies in India, major business houses including MSMEs, Public Sector Undertakings, Women Entrepreneurs, Multinational Companies, Banks, Financial Institutions, Start-ups and Professionals Firms to mention a few.",
            ].map((text, i) => (
              <motion.p key={i} variants={fadeUpVariant} className="text-base md:text-lg">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#DA2128] mr-3 align-middle" />
                {text}
              </motion.p>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Value Proposition — Reversed Folder-tab cards on #FDF2F1 field */}
      <section
        className="relative py-24 px-6 lg:px-20 overflow-hidden"
        style={{ backgroundColor: "#FDF2F1" }}
      >
        {/* Ambient floating motes */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(22)].map((_, i) => (
            <motion.span
              key={i}
              className="absolute block rounded-full"
              style={{
                width: 4 + (i % 4) * 2,
                height: 4 + (i % 4) * 2,
                background: i % 2 ? "rgba(218,33,40,0.18)" : "rgba(232,93,40,0.14)",
              }}
              initial={{ x: `${(i * 37) % 100}%`, y: `${(i * 53) % 100}%` }}
              animate={{
                y: [null, -60, 40, -20, 0],
                x: [null, 20, -24, 12, 0],
                opacity: [0.15, 0.55, 0.15],
              }}
              transition={{
                duration: 12 + (i % 6) * 2,
                repeat: Infinity,
                ease: "easeInOut",
                delay: (i % 7) * 0.6,
              }}
            />
          ))}
          <div className="absolute top-10 left-10 w-72 h-72 rounded-full bg-white/40 blur-3xl" />
          <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-white/30 blur-3xl" />
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-16 flex flex-col items-start md:items-center md:text-center gap-4"
          >
            
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 leading-[1.02] max-w-3xl">
              Membership <span className="italic text-[#DA2128]">Value</span> Proposition
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-xl">
              Four pillars of advantage — engineered to compound your influence, insight and reach.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12">
            {valuePropositions.map((vp, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.1,
                  type: "spring",
                  stiffness: 90,
                  damping: 16,
                }}
                whileHover={{ y: -10, scale: 1.015, transition: { duration: 0.25 } }}
                className="group relative transition-[filter] duration-300"
                style={{
                  filter: "drop-shadow(0 18px 38px rgba(40,12,12,0.10))",
                }}
              >
                {/* The reversed folder-tab card */}
                <div
                  style={{ clipPath: FOLDER_CLIP_REVERSED }}
                  className="relative h-full overflow-hidden bg-white"
                >
                  {/* --- abstract layers (clipped to the folder silhouette) --- */}
                  <div className="pointer-events-none absolute inset-0">
                    {/* theme wash top-right */}
                    <div
                      className={`absolute -top-20 -right-16 w-72 h-72 rounded-full bg-gradient-to-br ${vp.gradient} opacity-[0.12] blur-3xl`}
                    />
                    {/* theme wash bottom-left */}
                    <div
                      className={`absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-gradient-to-br ${vp.gradient} opacity-[0.08] blur-3xl`}
                    />
                    {/* concentric rings in the tab (now on left) */}
                    <div
                      className="absolute top-3 left-4 w-28 h-28 rounded-full border opacity-20"
                      style={{ borderColor: vp.hex }}
                    />
                    <div
                      className="absolute top-7 left-8 w-20 h-20 rounded-full border opacity-20"
                      style={{ borderColor: vp.hex }}
                    />
                    {/* dot matrix */}
                    <div
                      className="absolute bottom-6 right-6 w-28 h-20 opacity-[0.18]"
                      style={{
                        backgroundImage: `radial-gradient(${vp.hex} 1.4px, transparent 1.4px)`,
                        backgroundSize: "9px 9px",
                      }}
                    />
                    {/* hairline diagonal sheen on hover */}
                    <div className="absolute inset-0 bg-[linear-gradient(115deg,transparent_42%,rgba(255,255,255,0.85)_50%,transparent_58%)] opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                    {/* top inner accent rule tracing the tab step (now on left) */}
                    <div
                      className="absolute left-0 right-0 top-[30px] h-px opacity-25"
                      style={{
                        background: `linear-gradient(90deg, transparent 48%, ${vp.hex} 60%, transparent 100%)`,
                      }}
                    />
                  </div>

                  {/* Tab index number, parked in the raised tab (now on left) */}
                  <span
                    className={`absolute top-2.5 left-6 z-20 font-black text-2xl bg-gradient-to-br ${vp.gradient} bg-clip-text text-transparent leading-none`}
                  >
                    0{index + 1}
                  </span>

                  {/* --- content --- */}
                  <div className="relative z-10 p-8 md:p-10 pt-14 md:pt-16">
                    <div className="flex items-start gap-5">
                      <motion.div
                        whileHover={{ rotate: [0, -10, 10, -5, 5, 0] }}
                        transition={{ duration: 0.5 }}
                        className={`relative w-14 h-14 rounded-2xl bg-gradient-to-br ${vp.gradient} flex items-center justify-center flex-shrink-0`}
                        style={{ boxShadow: `0 10px 24px -6px ${vp.hex}66` }}
                      >
                        <div className="absolute inset-0 rounded-2xl bg-white/15 backdrop-blur-sm" />
                        <div className="relative text-white">{vp.icon}</div>
                        <div className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-white/40" />
                        <div className="absolute -bottom-1 -left-1 w-2 h-2 rounded-full bg-white/30" />
                      </motion.div>
                      <div className="flex-1 pt-1">
                        <h3
                          className={`text-xl md:text-2xl font-bold bg-gradient-to-r ${vp.gradient} bg-clip-text text-transparent leading-tight`}
                        >
                          {vp.title}
                        </h3>
                        <div
                          className="h-[3px] w-14 mt-2 rounded-full"
                          style={{
                            backgroundImage: `linear-gradient(90deg, ${vp.hex}, transparent)`,
                          }}
                        />
                      </div>
                    </div>

                    <ul className="mt-6 space-y-3.5">
                      {vp.points.map((point, i) => (
                        <motion.li
                          key={i}
                          initial={{ opacity: 0, x: -10 }}
                          whileInView={{ opacity: 1, x: 0 }}
                          viewport={{ once: true }}
                          transition={{ delay: i * 0.06 + 0.25 }}
                          className="flex items-start gap-3 group/item"
                        >
                          <span className="mt-[7px] relative flex-shrink-0">
                            <span
                              className="block w-2 h-2 rounded-full"
                              style={{ background: vp.hex }}
                            />
                            <span
                              className="absolute inset-0 w-2 h-2 rounded-full opacity-30 animate-ping"
                              style={{ background: vp.hex }}
                            />
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed group-hover/item:text-gray-900 transition-colors">
                            {point}
                          </span>
                        </motion.li>
                      ))}
                    </ul>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

    <HelpDeskSection />

    </div>
  );
}